if (!customElements.get('engraving-field')) {
  customElements.define(
    'engraving-field',
    class EngravingField extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('[data-engraving-input]');
        this.counter = this.querySelector('[data-engraving-counter]');
        this.optionIndex = parseInt(this.dataset.optionIndex, 10);
        this.noneValues = (this.dataset.noneValues || '')
          .split(',')
          .map((value) => value.trim().toLowerCase())
          .filter((value) => value.length > 0);

        if (this.input) {
          this.onInput = this.updateCounter.bind(this);
          this.input.addEventListener('input', this.onInput);
          this.updateCounter();
        }

        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (!this.belongsToSection(event.data.sectionId)) return;
          this.toggle(event.data.variant);
        });
      }

      disconnectedCallback() {
        this.variantChangeUnsubscriber?.();
        if (this.input && this.onInput) this.input.removeEventListener('input', this.onInput);
      }

      belongsToSection(sectionId) {
        const productInfo = this.closest('product-info');
        if (!productInfo) return true;
        return sectionId === (productInfo.dataset.originalSection || productInfo.dataset.section);
      }

      toggle(variant) {
        const active = this.isEngraved(variant);
        this.toggleAttribute('hidden', !active);

        if (!this.input) return;
        // Disabled inputs are not submitted, so the property only reaches the
        // cart when an engraved variant is selected.
        this.input.disabled = !active;
        this.input.required = active && this.dataset.required === 'true';
      }

      isEngraved(variant) {
        if (!variant) return false;
        if (!Number.isInteger(this.optionIndex) || this.optionIndex < 0) {
          return this.dataset.designMode === 'true';
        }

        const value = (variant.options?.[this.optionIndex] || '').trim().toLowerCase();
        if (value.length === 0) return false;

        return !this.noneValues.includes(value);
      }

      updateCounter() {
        if (!this.counter || !this.input) return;
        this.counter.textContent = (this.counter.dataset.template || '[count]').replace(
          '[count]',
          this.input.value.length
        );
      }
    }
  );
}
